import React from "react";
import InputField from "Components/CommonComponents/InputField";
import ButtonComponent from "Components/CommonComponents/button";
import { SignUpAction } from "Redux/Actions/AuthActions";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";

const GetQuotationComponent = () => {
  const dispatch = useDispatch();
  const initialValues = {
    name: "",
    email: "",
    mobile: "",
    address: "",
  };
  return (
    <Formik initialValues={initialValues} onSubmit={(values) => dispatch(SignUpAction(values))}>
      {({ setFieldValue, values }) => (
        <Form>
          <>
            <p className="text-center w-75 m-auto">
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
              invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
            </p>
            <div className="login-container">
              <InputField
                name="name"
                label="Name"
                maxWidth="320px"
                onChange={(event) => setFieldValue((values.name = event.target.value))}
              />
              <InputField
                name="email"
                type="email"
                label="Username"
                maxWidth="320px"
                onChange={(event) => setFieldValue((values.email = event.target.value))}
              />
              <InputField
                name="mobile"
                label="Phone/Mobile"
                maxWidth="320px"
                onChange={(event) => setFieldValue((values.mobile = event.target.value))}
              />
              <InputField
                name="address"
                label="Address"
                maxWidth="320px"
                onChange={(event) => setFieldValue((values.address = event.target.value))}
              />

              <ButtonComponent title="Send me quotation" type="submit" />
            </div>
          </>
        </Form>
      )}
    </Formik>
  );
};

export default GetQuotationComponent;
